module.exports = __webpack_public_path__ + "img/logo.1a30dca9.png";